module.exports = __webpack_public_path__ + "media/images/ad_flag-918a8c2c52f7a09ed60731a234ff4678.png";